import { render, staticRenderFns } from "./SmartMultiSelect.vue?vue&type=template&id=20b38a29&scoped=true"
import script from "./SmartMultiSelect.vue?vue&type=script&lang=js"
export * from "./SmartMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b38a29",
  null
  
)

export default component.exports